import Evented from './Evented'
import HostChannel from './HostChannel'
import IChannel from './interfaces/IChannel'
import ISubscriptionConfig from './interfaces/ISubscriptionConfig'

/**
 * Channel used for client subscriptions within a multiplexed connection
 */
export default class MultiplexChannel extends Evented implements IChannel {
  get isConnected () { return this.host.isConnected }

  public channelPath: string
  public lastMessageSequence = 0
  public options: ISubscriptionConfig

  private subscribers = 0
  private host: HostChannel

  get metrics () {
    return {
      channelPath: this.channelPath,
      subscribers: this.subscribers,
      lastMessageSequence: this.lastMessageSequence
    }
  }

  constructor (host: HostChannel, channelPath: string, opts: ISubscriptionConfig) {
    super()

    this.host = host
    this.channelPath = channelPath
    this.options = opts

    this.subscribe()
  }

  public subscribe () {
    if (this.subscribers < 1) {
      this.host.subscribeToChannel(this)
    }
    this.subscribers = this.subscribers + 1
  }

  public unsubscribe () {
    this.subscribers -= 1

    if (this.subscribers < 1) {
      this.host.unsubscribeFromChannel(this)
      this.lastMessageSequence = 0
      this.emit('destroy')
    }
  }
}
